const breadcrumbsData = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: 'User Access Management',
    children: [
      { title: 'New Request', path: '/user-roles/new-request' },
      { title: 'Request Status', path: '/user-roles/track-access-request' },
      { title: 'Report', path: '/user-roles/reports' },
      { title: 'Approval Delegation', path: '/user-roles/approval-rights' },
      { title: 'Ticket Summary', path: '/user-roles/ticket-summary' },
    ],
  },
  {
    title: 'New Request',
    path: '/user-roles/new-request',
    children: [],
  },
  {
    title: 'Request Status',
    path: '/user-roles/track-access-request',
    children: [],
  },
  {
    title: 'Report',
    path: '/user-roles/reports',
    children: [],
  },
  {
    title: 'Approval Delegation',
    path: '/user-roles/approval-rights',
    children: [],
  },
  {
    title: 'Ticket Summary',
    path: '/user-roles/ticket-summary',
    children: [],
  },
]

export default breadcrumbsData;